export enum IGFeatureLocked {
  CampaignGroupTemplate = 'CampaignGroupTemplate',
  PageListing = 'PageListing',
  Analytics = 'Analytics',
  PathAnalysis = 'PathAnalysis',
}

export interface IGFeatureLockedData {
  background?: string;
  backgroundColor?: string;
  illustration?: string;
  aspectRatio?: number;
  backdropFilter?: number;
  maxDescriptionWidth?: string;
  gradientBackground?: string;
}
